import React,{useState,useEffect} from 'react'
import { VerifyEmailStyle } from './VerifyEmail.styled'
import Footer from '../../components/footer/Footer'
import api from "../../api/configAxios"
import TopBar2 from '../../components/TopBar/TopBar2'
import { useParams } from 'react-router-dom'
import Controller from '../../common/controller'
import { checkEmail } from '../../api/EmailApi'
import { useQuery } from '@tanstack/react-query'
import { HeadingStyles2 } from '../../styles/HeadingStyles'

const VerifiedComponent=({verified})=>{
  
  const openApp=()=>{
    let ua = navigator.userAgent.toLowerCase();
    let isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
    if(isAndroid){
      window.location.href = 'https://play.google.com/store/apps/details?id=com.ocufiiinc.ocufii';
    }else{
      window.location.href = 'https://apps.apple.com/pk/app/ocufii/id6450452076';
    }
  }

  const resendEmail=async()=>{
    try {
      var response=await api.post(`${Controller.Email}/VerifyEmail`)
    } catch (error) {
      console.error(error)

    }
    
  }

  return <div className='body'>
      {verified===1 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/acceptIcon.png`} alt="Logo" className='imgLogo'  />
          <p className='smsTxt'>Verified!</p>
          <p className='smsTxt'>You have successfully verified your email</p>
          <button className='btn form-button' onClick={openApp}>Go to the App</button>
        </> 
      }
      {verified===2 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo" className='imgLogo' />
          <p className='smsTxt'>Email Verification Link Expired!</p>
          <p className='smsTxt'>It look like the verification link has expired. No worries,we can send you a new link to verify again</p>
          {/* <button className='btn form-button' onClick={resendEmail}>Resend Verification Email</button> */}
        </>
      }
      {verified===3 && 
        <>
          <HeadingStyles2>Ocufii Two-Step Verification</HeadingStyles2>
          <img src={`${process.env.PUBLIC_URL}/rejectIcon.png`} alt="Logo" className='imgLogo' />
          <p className='smsTxt'>Email Verification Link Expired!</p>
          <p className='smsTxt'>It look like the verification link has expired. No worries,we can send you a new link to verify again</p>
          <p className='smsTxt2'>Having repeated issues verifying? Contact support</p>
          {/* <button className='btn form-button' onClick={resendEmail}>Resend Verification Email</button> */}
        </>
      }
  </div> 
}
const VerifyEmail = () => {
  const [verified, setVerified] = useState("")
  const {email,token}=useParams()
  const [enableAPI, setEnableAPI] = useState(false)

 
  const {
    status : verifyEmailStatus,
    data: verifyEmailData,
  }=useQuery({
    queryKey:["verifyLink",token],
    queryFn:()=>checkEmail("verifyLink",email,token),
    enabled:enableAPI,
    onSuccess:(data)=>{
      if(data.status===400){
        setVerified(2)
      }else{
        setVerified(1)
      }
      setEnableAPI(false)
    },
    onError:()=>{
      setVerified(3)
    }

  })

  useEffect(() => {
    if(email || token){
      setEnableAPI(true)
    }else{
      setEnableAPI(false)
    }
  }, [email,token])
  
  

  return (
    <VerifyEmailStyle>
        <TopBar2  />
        {verifyEmailStatus==="loading"
          ?
          <div className='body'>
            <p className='description'>Loading ...</p>
          </div>
          : 
         <VerifiedComponent verified={verified}  />
        }  
        <Footer />
    </VerifyEmailStyle>
  )
}

export default VerifyEmail